import { FC, useState } from 'react'

import styled from 'styled-components'

import { LabelForGenreOrLanguage } from 'src/Components/LabelForGenreOrLanguage'
import { capitalizeWords } from 'src/Helpers/layoutHelpers'
import {
  GenreWithCurators,
  PopularGenres,
} from 'src/Redux/spotifyCampaignGenresApi'

type Props = {
  genres?: PopularGenres[]
  selectedGenres?: GenreWithCurators[]
  onClickGenre: (genre: GenreWithCurators) => void
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Title = styled.h3`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  width: 100%;
  margin: 0;
`
const List = styled.ul`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
  padding: 0px;
  margin: 0px;
`

export const PopularGenresList: FC<Props> = ({
  genres,
  selectedGenres,
  onClickGenre,
}) => {
  const [expandedSubTitles, setExpandedSubTitles] = useState(new Set())

  if (!genres || genres.length === 0) {
    return null
  }

  const handleExpand = (subTitle: string): void => {
    setExpandedSubTitles((prev) => {
      const next = new Set(prev)
      next.add(subTitle)
      return next
    })
  }

  return (
    <>
      {genres.map((item) => {
        if (!item.genres || item.genres.length === 0) {
          return null
        }
        const isExpanded = expandedSubTitles.has(item.subTitle)
        const extraGenres = item.extraGenres ?? []
        const visibleGenres = isExpanded
          ? [...item.genres, ...extraGenres]
          : item.genres
        const moreCount = extraGenres.length
        return (
          <Container key={item.subTitle}>
            <Title>{item.subTitle}</Title>
            <List>
              {visibleGenres.map((genre) => (
                <LabelForGenreOrLanguage
                  key={genre.id}
                  title={capitalizeWords(genre.genreName)}
                  count={genre.curatorsCount}
                  markedSelected={selectedGenres?.some(
                    (selectedGenre) => selectedGenre.id === genre.id,
                  )}
                  onClick={() => onClickGenre(genre)}
                />
              ))}
              {!isExpanded && moreCount > 0 && (
                <LabelForGenreOrLanguage
                  title={`+ ${moreCount} more`}
                  onClick={() => handleExpand(item.subTitle)}
                />
              )}
            </List>
          </Container>
        )
      })}
    </>
  )
}
